import { deleteInvalidKeys } from './onp-util';

export * from './dom-util';
export * from './flag-util';
export * from './i18n-util';
export * from './locale-util';
export * from './log-util';
export * from './onp-util';
export * from './param-util';
export * from './router-util';
export * from './token-util';

export const redirect = (uri, params) => {
  // Remove undefined or null params
  deleteInvalidKeys(params);

  const redirectUri = `${uri}?${new URLSearchParams(params)}`;
  window.location = redirectUri;
};
